import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { fontFamily } from "@clockwise/web-commons/src/styles/type.styles";
import { background, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { cwMuiBase } from "@clockwise/design-system";

export const homeTheme = Object.assign({}, cwMuiBase, {
  fontFamily,
});

export const homeStyles: CSSProperties = {
  fontFamily,
  display: "flex",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  height: "100%",
  backgroundColor: background.page,
};

export const body: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  overflowY: "auto",
  marginTop: 80,
  backgroundColor: greys.palePaleGrey,
};
